"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _base = require("@site/pattern-library-utils/base.functions");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
/**
 * Custom hook that provides functionality to scroll to the next element
 *
 * @returns {Object} An object containing the `registerRef` and `scrollToNext` functions
 */
function useScrollToNext() {
  const refs = (0, _react.useRef)([]);
  const {
    width
  } = (0, _base.useWindowSize)();
  const registerRef = index => el => {
    if (el) {
      refs.current[index] = el;
    }
  };
  const scrollToNext = index => {
    if (width <= _breakpoints.size.tabletLg) {
      const currentElement = refs.current[index];
      if (currentElement) {
        const nextElement = currentElement.nextElementSibling;
        if (nextElement) {
          nextElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    }
  };
  return {
    refs,
    registerRef,
    scrollToNext
  };
}
var _default = exports.default = useScrollToNext;